const AuthToken = {
    getUser: () => localStorage.getItem('userAuthToken') || '',

    setUser: (token) => localStorage.setItem('userAuthToken', token),

    removeUser: () => localStorage.removeItem('userAuthToken'),

    isUser: () => !!localStorage.getItem('userAuthToken'),

    isAuthenticated: () => !!localStorage.getItem('userAuthToken') || !!localStorage.getItem('vendorAuthToken'),

};

export default AuthToken;
